import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { isMobile } from '../../configs/utils';
import { ACTION } from "./types";
import { ROUTE } from "../../routes";
const _isMobile = isMobile();
export const ArnDetailsDS = (showARNScreen, isARNRequired) => {
    let DS;
    DS = {
        arnDetailsContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            hide: !showARNScreen,
            maxWidth: _isMobile ? '100%' : 400,
            bgColor: ColorTokens.White,
            borderConfig: {
                borderColor: ColorTokens.Primary_10,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: {
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.Size32,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.Size32,
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.Size32,
                bottom: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.Size32,
            },
            widgetItems: [
                { id: 'arnDetailTextTitle1', type: WIDGET.TEXT },
                { id: 'arnDetailContainerSpace0', type: WIDGET.SPACE },
                // ------ //
                isARNRequired ? {} : { id: 'haveARNSelectContainer', type: WIDGET.STACK },
                isARNRequired ? {} : { id: 'arnDetailContainerInputStack', type: WIDGET.STACK },
                isARNRequired ? {} : { id: 'arnDetailContainerSpace2', type: WIDGET.SPACE },
                isARNRequired ? {} : { id: 'donthaveARNSelectContainer', type: WIDGET.STACK },
                // ------ //
                // ------ //
                isARNRequired ? { id: 'arnDetailContainerInput', type: WIDGET.INPUT } : {},
                // ------ //
                { id: 'arnDetailContainerSpace3', type: WIDGET.SPACE },
                { id: 'arnDetailsContainerContinue', type: WIDGET.BUTTON },
            ],
        },
        arnDetailContainerInputStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            hide: false,
            widgetItems: [
                { id: 'arnDetailContainerSpace1', type: WIDGET.SPACE },
                { id: 'arnDetailContainerInput', type: WIDGET.INPUT },
            ]
        },
        arnDetailContainerInput: {
            preText: 'ARN- ',
            onlyNumeric: true,
            value: '',
            isFocus: true,
            type: InputTypeToken.MOBILE,
            state: InputStateToken.DEFAULT,
            title: isARNRequired ? "Enter ARN number *" : "Enter ARN number",
            keyboardType: KeyboardTypeToken.numberPad,
            placeholder: "",
            ...isARNRequired && {
                charLimit: 6,
                charLimitVisibility: false,
            },
            action: {
                type: ACTION.ARN_INPUT_ACTION,
                payload: { value: "", widgetId: "arnDetailContainerInput" },
                routeId: ROUTE.PARTNER_SIGNUP,
                isARNRequired: isARNRequired
            },
            caption: isARNRequired ? { error: "" } : { error: "Enter a valid ARN number" },
            showErrorOnFocus: false
        },
        arnDetailTextTitle1: {
            label: 'Enter your ARN details',
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            color: ColorTokens.Grey_Night,
            lineHeight: 16,
        },
        haveARNSelectContainer: {
            type: StackType.row,
            widgetItems: [
                { id: 'haveARNSelectContainerRadio1', type: WIDGET.ICON },
                { id: 'haveARNSelectContainerRadioS1', type: WIDGET.SPACE },
                { id: 'haveARNSelectContainerText1', type: WIDGET.TEXT }
            ],
            action: {
                type: ACTION.ARN_CHECK_ACTION,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: true
                }
            }
        },
        donthaveARNSelectContainer: {
            type: StackType.row,
            widgetItems: [
                { id: 'dontARNSelectContainerRadio1', type: WIDGET.ICON },
                { id: 'dontARNSelectContainerRadioS1', type: WIDGET.SPACE },
                { id: 'dontARNSelectContainerText1', type: WIDGET.TEXT }
            ],
            action: {
                type: ACTION.ARN_CHECK_ACTION,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: false
                }
            }
        },
        dontARNSelectContainerText1: {
            label: 'I don’t have an ARN number',
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 20,
        },
        dontARNSelectContainerRadio1: {
            name: IconTokens.RadioCircleNotFilled,
            size: IconSizeTokens.XXL
        },
        haveARNSelectContainerRadio1: {
            name: IconTokens.RadioCircleFilled,
            size: IconSizeTokens.XXL
        },
        haveARNSelectContainerText1: {
            label: 'I have an ARN number',
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 20,
        },
        arnDetailsContainerContinue: {
            label: 'Continue',
            fontSize: FontSizeTokens.MD,
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            action: {
                routeId: ROUTE.PARTNER_SIGNUP,
                type: ACTION.ARN_SUBMIT_ACTION,
                payload: {}
            }
        },
        arnDetailContainerSpace0: { size: SizeTypeTokens.XL },
        arnDetailContainerSpace1: { size: SizeTypeTokens.LG },
        haveARNSelectContainerRadioS1: { size: SizeTypeTokens.MD },
        dontARNSelectContainerRadioS1: { size: SizeTypeTokens.MD },
        arnDetailContainerSpace2: { size: SizeTypeTokens.XXXL },
        arnDetailContainerSpace3: { size: SizeTypeTokens.XXXL },
    };
    return DS;
};
